
import { iterateOverFilters, getColumnParamsByDataField } from './utils'

export default {
  middlewareForRequest: ({ loadOptions }) => {
    /* change loadOptions.sort */
    let sort = loadOptions.sort
    if (sort && sort.length) {
      for (let ii = 0; ii < sort.length; ii++) {
        if (sort[ii].isExpanded !== undefined) {
          delete sort[ii].isExpanded
        }
        sort[ii].selector = getColumnParamsByDataField(sort[ii].selector).keyForRequest
      }
    }

    /* change loadOptions.filter */
    loadOptions.filter = iterateOverFilters(loadOptions.filter, ([paramKeys, logicalOperator, filterValue]) => {
      const columnParams = getColumnParamsByDataField(paramKeys)
      return [
        columnParams && columnParams.keyForRequest ? columnParams.keyForRequest : paramKeys,
        logicalOperator,
        filterValue,
      ]
    })

    /* default values */
    if (!loadOptions.take) loadOptions.take = 100;

    return { ...loadOptions, sort }
  },
}
